import {
    CLEAR_CURRENT_JOB, CLEAR_CURRENT_LOCATION, GET_ALL_LOCATIONS,
    GET_ALL_LOCATIONS_DONE, GET_JOBS_LIST, GET_RECENTLY_POSTED,
    GET_SKILLS, GET_TOP_CATEGORIES, GET_TOP_CITIES, RESET_CATEGORY,
    RESET_USER_PROFILE, RESET_USER_SESSION, SET_CATEGORY,
    SET_CURRENT_JOB, SET_CURRENT_LOCATION, SET_USER_PROFILE,
    SET_USER_SESSION, GET_JOB_CATEGORIES,
    GET_SKILLS_FETCH_DONE
} from "./actionTypes";

export const getJobsList = () => ({
    type: GET_JOBS_LIST,
});

export const getRecentlyPostedJobs = () => ({
    type: GET_RECENTLY_POSTED,
});

export const getTopCategories = () => ({
    type: GET_TOP_CATEGORIES,
});

export const getJObCategories = () => ({
    type: GET_JOB_CATEGORIES,
});

export const getTopCities = () => ({
    type: GET_TOP_CITIES,
});

export const getSkills = () => ({
    type: GET_SKILLS,
});

export const getRecentJobs = () => ({
    type: GET_RECENTLY_POSTED,
});

export const setCurrentJob = (jobId) => ({
    type: SET_CURRENT_JOB,
    payload: jobId
});

export const setCurrentLocation = (location) => ({
    type: SET_CURRENT_LOCATION,
    payload: location,
});

export const resetCurrentLocation = () => ({
    type: CLEAR_CURRENT_LOCATION,
});

export const setCategory = (category) => ({
    type: SET_CATEGORY,
    payload: category,
});

export const resetCategory = () => ({
    type: RESET_CATEGORY,
});

export const getAllLocations = () => ({
    type: GET_ALL_LOCATIONS,
});

export const getAllLocationsDone = () => ({
    type: GET_ALL_LOCATIONS_DONE,
});

export const setUserSession = (user) => ({
    type: SET_USER_SESSION,
    payload: user,
});

export const setUserProfile = (user) => ({
    type: SET_USER_PROFILE,
    payload: user,
});

export const resetUserSession = () => ({
    type: RESET_USER_SESSION
});

export const resetUserProfile = () => ({
    type: RESET_USER_PROFILE
});

export const clearSelectedJob = () => ({
    type: CLEAR_CURRENT_JOB
});

export const getSkillsDone = (payload) => ({
    type: GET_SKILLS_FETCH_DONE,
    payload,
});

// Search state management actions
export const setSearchData = (searchData) => ({
    type: 'SET_SEARCH_DATA',
    payload: searchData,
});

export const clearSearchData = () => ({
    type: 'CLEAR_SEARCH_DATA',
});

export const setSearchResults = (results) => ({
    type: 'SET_SEARCH_RESULTS',
    payload: results,
});

export const setSearchLoading = (loading) => ({
    type: 'SET_SEARCH_LOADING',
    payload: loading,
});